module.exports = __webpack_public_path__ + "img/product_banner.0bd1fd3b.png";